<template>
    <div id="Page" class="Page" v-if="data">
      <div id="Top" class="Section Section_grey">

        <div class="Section_wrapper">
          <transition name="bottom" appear>
            <h6 v-html="data.top_subtitle" v-if="data.top_subtitle"></h6>
          </transition>
          <transition name="bottom" appear>
            <h3 v-html="data.top_title">L'analyse</h3>
          </transition>
          <transition name="bottom" appear>
            <div class="Content" v-html="data.top_content" v-if="data.top_content"></div>
          </transition>
          <transition name="bottom" appear>
            <a :href="data.top_cta.link ? data.top_cta.link : data.top_cta.file" target="_blank" v-if="data.top_cta.label" @click="clickCtaTop"><button class="Cta Cta_line" v-html="data.top_cta.label"></button></a>
          </transition>

          <transition name="fade" appear>
            <img :src="data.top_image" v-if="data.top_image"/>
          </transition>

          <PageNav :data="nav" ref="nav" :hash="true" />
        </div>

      </div>

      <div id="Content" class="Section">

        <div class="Section_wrapper">
          <PageArticle :data="article" v-for="(article, index) in data.articles" :id="'Article' + (index + 1)" :key="index" :index="index + 1" @navRefresh="onNavRefresh"/>
        </div>

      </div>

      <Footer />
    </div>
</template>

<script>
  import page from '@/mixins/page'
  import Vue from 'vue'
  import router from '@/router'

  import { mapActions, mapState } from 'vuex' 

  import Footer from '@/components/partials/Footer'
  import PageNav from '@/components/PageNav'
  import PageArticle from '@/components/PageArticle'

  export default {
    name: "Page",
    mixins: [ 'page' ],
    components: { Footer, PageNav, PageArticle },
    metaInfo: {
      title: "Baromètre Qualitel 2019 : consultez l'analyse complète de nos experts",
      meta: [
        {
          property: 'og:title',
          content: "Baromètre Qualitel 2019 : consultez l'analyse complète de nos experts"
        },
        {
          property: 'og:description',
          content: "Qualité du logement : enjeux d'attractivité des territoires. Où fait-il bon se loger pour les Français ? 5000 personnes interrogées en zones rurales, villes moyennes et grandes métropoles."
        },
        {
          property: 'og:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-4.jpg'
        },
        {
          property: 'twitter:title',
          content: "Baromètre Qualitel 2019 : consultez l'analyse complète de nos experts"
        },
        {
          property: 'twitter:description',
          content: "Qualité du logement : enjeux d'attractivité des territoires. Où fait-il bon se loger pour les Français ? 5000 personnes interrogées en zones rurales, villes moyennes et grandes métropoles."
        },
        {
          property: 'twitter:image',
          content: 'https://www.qualitel.org/jevalue-mon-logement/static/images/social/social-4.jpg'
        }
      ]
    },
    data() {
      return {
        data: null,
        nav: []
      }
    },
    beforeRouteEnter (to, from, next) {
      Vue.$api.getPage(to.params.slug)
      .then(response => {
        next(vm => vm.setData(response.data))
      })
      .catch( () => {
        router.push({ name: "404" })
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.$api.getPage(to.params.slug)
      .then(response => {
        next(this.setData(response.data))
      })
      .catch( () => {
        this.$router.push({ name: "404" })
      })
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    methods: {
      ...mapActions([
        
      ]),
      clickCtaTop()
      {
        this.$gtm.trackEvent({ category: 'button_' + this.$route.params.slug + '_cta', action: 'click', label: this.$route.params.slug + '_CTA_' + this.data.top_cta.label.split(' ')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") })
      },
      setData(data)
      {
        if(!data || data.length <= 0)
        {
          this.$router.push({ name: "404" })
        }

        this.data = data
        this.nav = []
        
        for (let i = 0; i < this.data.articles.length; i++) {
          const element = this.data.articles[i];

          if(element.in_nav)
          {
            this.nav.push({ to: this.$route.path + '#Article' + Number(i + 1), label: element.nav_name })
          }
        }
      },
      onNavRefresh(to)
      {
        this.$refs.nav.refresh(to)
      }
    }
  }
</script>

<style lang="stylus">
#Page

  #Content

    .Section_wrapper

      padding-top 0px

    .PageArticle:last-child

      border-bottom 0px

  #Top

    z-index 2

    @media $large

      overflow visible

    .Section_wrapper

      padding-bottom 0px!important
      padding-top 100px
      box-sizing border-box
      min-height calc(100vh - 140px)
      min-height calc((100vh - 140px) - var(--vh, 0px));

      @media $small

        padding-top 40px

    .PageNav

      max-width none
      margin-top 0px
      border-top 1px solid rgba(31,39,109,0.1)

      li a:before

        background-color $blue

      .vs__selected, .vs__search, .vs__dropdown-option, input, input::placeholder, select, select::placeholder

        color $blue

      svg, i

        fill $blue
        color $blue

    .Cta

      margin-top 30px

    h2

      transition-delay 0.1s

    .Content

      transition-delay 0.2s

    a

      transition-delay 0.3s

    img

      width 100%
      transition-delay 0.4s
      max-width 860px
      margin auto auto

.ie

  #Page

    #Content

      .Section_wrapper

        display inline-block

    #Top

      .Section_wrapper

        min-height auto 

        img

          margin-top 40px

.edge

  #Top

    overflow-y visible
    overflow initial
</style>